import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { CookieConsentBanner } from './banner/CookieConsentBanner.tsx';

const LazyForPaintCookieConsentBanner = lazyForPaint<typeof CookieConsentBanner>(
	() =>
		// chunk name is async-cc-banner to avoid scripts with cookie/banner keywords getting blocked
		import(/* webpackChunkName: "async-cc-banner" */ './banner/CookieConsentBanner.tsx').then(
			({ CookieConsentBanner }) => CookieConsentBanner,
		),
	{
		ssr: true,
		entryFsSsrLiftImportToModule: true,
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		includeInShellOnlySsrBundle: true,
		entryFsSsrOverride: 'include',
	},
);

export const CookieConsentBannerAsync = () => (
	<Box xcss={boxStyles}>
		<JSErrorBoundary
			id="async-cookie-consent-banner"
			packageName="jiraCookieConsentBanner"
			teamName="Magma"
		>
			<Placeholder name="async-cookie-consent-banner" fallback={null}>
				<LazyForPaintCookieConsentBanner />
			</Placeholder>
		</JSErrorBoundary>
	</Box>
);

const boxStyles = xcss({
	backgroundColor: 'elevation.surface.sunken',
	height: '100%',
});
